import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class APIService {

    axiosInstance: AxiosInstance;

    constructor() {

        const baseURL = import.meta.env.VITE_DS_HOSTNAME;

        if (!baseURL) {
            throw new Error('Error: No base URL set');
        }

        const requestConfig: AxiosRequestConfig = {
            timeout: 60000,
            headers: {
                'x-b3-traceid': this.generateSearchId(),
            }
        };
        this.axiosInstance = axios.create(requestConfig);
        this.axiosInstance.interceptors.response.use(
            response => this.rejectNonJsonResponses(response),
            error =>  Promise.reject(error)
        );
    }

    postData(path: string, data: object, config?: AxiosRequestConfig) {
        return this.axiosInstance.post(path, data, {
            headers: {
                'x-b3-spanid': this.generateSearchId()
            },
            ...config
        });
    }

    getData(path: string, params?: object, config?: AxiosRequestConfig) {
        return this.axiosInstance.get(path, {
            headers: {
                'x-b3-spanid': this.generateSearchId()
            },
            params,
            ...config
        }).then(response => this.unWrapResponse(response));
    }

    private generateSearchId() {
        return Math.floor(Math.random() * 1000000000).toString(16);
    }

    /**
     * IBM TAM returns a login.html when the session expires
     * Reject this response
     */
    // tslint:disable-next-line:no-any
    private rejectNonJsonResponses(response: AxiosResponse<any>) {
        return String(response.headers['content-type']).indexOf('application/json') !== -1
            ? response : Promise.reject(response);
    }

    /**
     * @param response if the responses data is wrapped in { result: any }
     * return the nested data
     */
    // tslint:disable-next-line:no-any
    private unWrapResponse(response: AxiosResponse<any>) {
        return response.data.result ? response.data.result : response.data;
    }
}